import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  generateKubernetesResourcePodsRequestFilters,
  KubernetesResourcePodsRequestFiltersData,
} from "./utils/helpers/kubernetes-reosurce-details-drawer-data/generateKubernetesResourcePodsRequestFilters";
import { cloudChiprApi } from "@/services/cloudchipr.api";

export const getKubernetesLiveUsageMgmtPodsDataForDetailsDrawerThunk =
  createAsyncThunk(
    "getKubernetesLiveUsageMgmtPodsDataForDetailsDrawer",
    async (args: KubernetesResourcePodsRequestFiltersData, { dispatch }) => {
      if (resourceTypesWithoutPodsData.includes(args.resourceType)) {
        return;
      }

      const filterItems = generateKubernetesResourcePodsRequestFilters(args);

      return await dispatch(
        cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentKubernetesByTypeResources.initiate(
          {
            type: "kubernetes_pod",
            body: {
              filter: {
                node_type: "group",
                operator: "and",
                items: filterItems,
              },
            },
          },
        ),
      ).unwrap();
    },
  );

const resourceTypesWithoutPodsData = ["kubernetes_job", "kubernetes_pod"];
